<template>
  <div class="list">
    <ul>
      <li v-for="(item,key) in listArr" :key="item.index" v-show="key < num">
        <router-link :to="{name:item.path}">
          <img :src="item.img" />
          <span>{{item.title}}</span>
        </router-link>
      </li>
    </ul>
    <p @click="showMore" v-show="listArr.length > num">{{txt}}</p>
  </div>
</template>
<script>
export default {
  name: "list",
  data() {
    return {
      isShow: true,
      txt: "显示全部",
      num: 3
    };
  },
  methods: {
    showMore() {
      this.isShow = !this.isShow;
      this.num = this.isShow ? 3 : this.listArr.length;
      this.txt = this.isShow ? "显示全部" : "收起";
    }
  },
  props: ["listArr"]
};
</script>
<style scoped>
.list ul li {
  display: inline-block;
  vertical-align: top;
  width: 30%;
  margin: 1.5%;
  text-align: center;
  cursor: pointer;
}
.list ul li img {
  width: 100%;
  display: block;
  height: 200px;
}
.list ul li span {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 10px 0;
  font-size: 18px;
}
.list p{
  text-align: center;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/list/list.vue